/**
 * coming-soon-interest.js (English)
 * Loads the interested-count and submits interest declarations
 * to the backend at back.christasflor.com/ad.
 */
(function () {
  'use strict';
 
  var BACKEND = 'https://back.christasflor.com/ad';
 
  document.querySelectorAll('.coming-soon-interest').forEach(function (root) {
    var productId     = root.dataset.productId;
    var productHandle = root.dataset.productHandle;
    var productTitle  = root.dataset.productTitle;
    var goal          = parseInt(root.dataset.goal, 10) || 100;
 
    var fill    = root.querySelector('.csi-progress__fill');
    var countEl = root.querySelector('.csi-count');
    var emailEl = root.querySelector('.csi-email');
    var submit  = root.querySelector('.csi-submit');
    var message = root.querySelector('.csi-message');
 
    // ---- Load current count ----
    function loadCount() {
      fetch(BACKEND + '/count.php?pid=' + encodeURIComponent(productId), {
        method: 'GET'
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.ok && data.counts) {
            var c = data.counts[productId] || 0;
            renderCount(c);
          }
        })
        .catch(function () { /* silent: bar stays at – */ });
    }
 
    function renderCount(c) {
      countEl.textContent = c;
      var pct = Math.min(100, Math.round((c / goal) * 100));
      fill.style.width = pct + '%';
    }
 
    // ---- Show a status message ----
    function showMessage(text, kind) {
      message.textContent = text;
      message.hidden = false;
      message.className = 'csi-message csi-message--' + (kind || 'info');
    }
 
    // ---- Submit ----
    function sendInterest() {
      var email = (emailEl.value || '').trim();
      if (!email || email.indexOf('@') === -1) {
        showMessage('Please enter a valid email address.', 'error');
        return;
      }
 
      submit.disabled = true;
      submit.classList.add('is-loading');
 
      fetch(BACKEND + '/interest.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_id: productId,
          product_handle: productHandle,
          product_title: productTitle,
          email: email
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.ok) {
            if (data.status === 'already_confirmed') {
              showMessage('You\'re already on the list — thank you!', 'success');
            } else {
              showMessage('Almost done! Please confirm the link in your email.', 'success');
            }
            emailEl.value = '';
          } else {
            showMessage('Something went wrong. Please try again later.', 'error');
            submit.disabled = false;
          }
        })
        .catch(function () {
          showMessage('Connection failed. Please try again later.', 'error');
          submit.disabled = false;
        })
        .finally(function () {
          submit.classList.remove('is-loading');
        });
    }
 
    submit.addEventListener('click', sendInterest);
    emailEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); sendInterest(); }
    });
 
    loadCount();
  });
})();
 